import { APP_INITIALIZER, NgModule } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ApplicationInsightsModule } from '@markpieszak/ng-application-insights';
import { HeaderComponent } from '@progress/kendo-angular-dateinputs/dist/es2015/calendar/header.component';
import { MessageService } from '@progress/kendo-angular-l10n';
import { TranslateLoader, TranslateModule, TranslateStaticLoader } from 'ng2-translate';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';
import { ConfigService } from './core/config.service';
import { KendoMessageService } from './core/kendo-message.service';
import { DistributionModule } from './modules/distribution/distribution.module';
import { DomainModule } from './modules/domain/domain.module';
import { LoginModule } from './modules/login/login.module';

export function translateFactory(http: Http): TranslateStaticLoader {
    return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

export function configServiceFactory(configService: ConfigService): Function {
    return (): any => configService.load();
}

@NgModule({
    declarations: [
        AppComponent, HeaderComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpModule,
        RouterModule.forRoot(appRoutes, {}),
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: translateFactory,
            deps: [Http]
        }),
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: 'toast-bottom-center',
            preventDuplicates: true,
        }),
        ApplicationInsightsModule.forRoot({
            instrumentationKeySetlater: true
        }),
        DomainModule,
        LoginModule,
        DistributionModule
    ],
    providers: [
        ConfigService,
        {
            provide: APP_INITIALIZER,
            useFactory: configServiceFactory,
            deps: [ConfigService],
            multi: true
        },
        { provide: MessageService, useClass: KendoMessageService }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts